import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Icon, Div, Label, Modal, Checkbox } from '@pinpoint/design-kit';

import Button from 'src/components/button';

export function TimedPopup({ enabled, isBlocked, onClick, delay, block, content, okText, cancelText }) {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    setIsOpen(false);
  };
  const onBlock = () => {
    block();
  };
  useEffect(() => {
    if (enabled && !isBlocked()) {
      setTimeout(() => {
        setIsOpen(true);
      }, delay);
    }
  }, [enabled, isBlocked, delay]);
  return (
    <Modal isOpen={isOpen} onClose={onClose} align="center" rounded="md" p={{ x: '1.25rem', y: '1.5rem' }}>
      <Icon name="Cross" pos="absolute" top="1rem" right="1rem" size="16px" onClick={onClose} cursor="pointer" />
      {content}
      <Label align="center" m={{ b: '0.5rem' }} textSize="16">
        <Checkbox
          onClick={() => {
            onBlock();
          }}
          size="1rem"
        />{' '}
        &nbsp; Do not show this message again.
      </Label>
      <Div d="flex" justify="flex-end">
        <Button buttonStyle="secondary" onClick={onClose}>
          {cancelText}
        </Button>
        <Button
          buttonStyle="primary"
          onClick={() => {
            onClose();
            onClick();
          }}
        >
          {okText}
        </Button>
      </Div>
    </Modal>
  );
}

TimedPopup.propTypes = {
  enabled: PropTypes.bool,
  isBlocked: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  delay: PropTypes.number,
  block: PropTypes.func.isRequired,
  content: PropTypes.node.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
};

TimedPopup.defaultProps = {
  enabled: true,
  delay: 1000,
  okText: 'OK',
  cancelText: 'CANCEL',
};
